import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "kt_wrapper",
  class: "d-flex flex-column flex-row-fluid wrapper"
}
const _hoisted_2 = {
  id: "mob-header",
  class: "d-lg-none text-white custom-container py-4"
}
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" YellowBeard ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" YellowBeard ")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_7 = {
  id: "kt_content",
  class: "content d-flex flex-column flex-column-fluid"
}
const _hoisted_8 = { class: "post d-flex flex-column-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_KTAside = _resolveComponent("KTAside")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTMobilePageTitle = _resolveComponent("KTMobilePageTitle")!
  const _component_InnerHeader = _resolveComponent("InnerHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_KTFooter = _resolveComponent("KTFooter")!
  const _component_KTScrollTop = _resolveComponent("KTScrollTop")!
  const _component_KTDrawerMessenger = _resolveComponent("KTDrawerMessenger")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.loaderEnabled)
      ? (_openBlock(), _createBlock(_component_InnerLoader, {
          key: 0,
          loading: !!_ctx.loader
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ["page d-flex flex-row flex-column-fluid layout-default", [_ctx.asideTheme === 'light' && 'layout-light', _ctx.asideTheme === 'dark' && 'layout-dark']]
    }, [
      _createVNode(_component_KTAside, { asideOpened: _ctx.asideOpened }, null, 8, ["asideOpened"]),
      _createVNode("div", _hoisted_1, [
        _createVNode("header", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.asideTheme === 'dark')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/dashboard"
                }, {
                  default: _withCtx(() => [
                    _createVNode("img", {
                      alt: "Logo",
                      src: _ctx.dynamicAsset,
                      class: "h-40px logo"
                    }, null, 8, ["src"]),
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.asideTheme === 'light')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/dashboard"
                }, {
                  default: _withCtx(() => [
                    _createVNode("img", {
                      alt: "Logo",
                      src: _ctx.dynamicAsset,
                      class: "h-40px logo"
                    }, null, 8, ["src"]),
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("button", {
            class: `aside-opener ${_ctx.asideOpened ? 'aside-opened' : ''}`,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.asideHandler && _ctx.asideHandler(...args)))
          }, [
            _hoisted_6
          ], 2)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", {
              class: [{
                            'container-fluid': _ctx.contentWidthFluid,
                            container: !_ctx.contentWidthFluid
                        }, "custom-container"]
            }, [
              (_ctx.subheaderDisplay)
                ? (_openBlock(), _createBlock(_component_KTMobilePageTitle, {
                    key: 0,
                    breadcrumbs: _ctx.breadcrumbs,
                    title: _ctx.pageTitle
                  }, null, 8, ["breadcrumbs", "title"]))
                : _createCommentVNode("", true),
              _createVNode(_component_InnerHeader, {
                margin: 10,
                pageHeader: _ctx.pageHeader
              }, null, 8, ["pageHeader"]),
              _createVNode(_component_router_view)
            ], 2)
          ])
        ]),
        _createVNode(_component_KTFooter)
      ])
    ], 2),
    _createVNode(_component_KTScrollTop),
    _createVNode(_component_KTDrawerMessenger),
    _createVNode(_component_KTUserMenu)
  ], 64))
}